// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* head bar text color */
@font-face {
  color: #000;
  font-family: Roboto-Black;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Bold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-SemiBold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Light;
  src: url("/assets/fonts/Roboto-Light.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Medium;
  src: url("/assets/fonts/Roboto-Medium.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Regular;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Thin;
  src: url("/assets/fonts/Roboto-Thin.ttf") format("truetype");
}
:host {
  display: block;
}
:host .task-block {
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
}
:host .task-block .task-item {
  width: 40%;
}
:host .main-applicant {
  position: relative;
  width: 160px;
  border: 1px solid #ddd;
  height: 160px;
  background: #f1f1f1;
}
:host .main-applicant .actions {
  position: absolute;
  bottom: 15px;
  left: 15px;
  opacity: 0;
}
:host .main-applicant .actions button,
:host .main-applicant .actions cs-file-upload {
  border: none;
  background: #ddd;
  margin-right: 10px;
  padding: 2px;
  width: 30px;
  height: 30px;
}
:host .main-applicant .actions button cs-icon,
:host .main-applicant .actions cs-file-upload cs-icon {
  width: 15px;
  height: 15px;
}
:host .main-applicant .actions button:hover,
:host .main-applicant .actions cs-file-upload:hover {
  background: #cac9c9;
}
:host .main-applicant .actions cs-file-upload {
  padding: 7px;
}
:host .main-applicant .overlay {
  position: absolute;
  background: transparent;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 158px;
  opacity: 0;
}
:host .main-applicant:hover .overlay {
  background: rgba(255, 255, 255, 0.75);
  opacity: 1;
  cursor: pointer;
}
:host .main-applicant:hover .actions {
  opacity: 1;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
